module.exports = __webpack_public_path__ + "img/japan-diabetes-mellitus-female.05029d64.png";